import { makeStyles, Theme } from '@material-ui/core/styles';

export const useClasses = makeStyles((theme: Theme) => ({
  tagList: {
    height: 140,
    overflowY: 'scroll',
    '&::-webkit-scrollbar': {
      width: '6px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.grey[400],
      borderRadius: 7,
    },
  },
  linkButton: {
    marginRight: '3px',
    marginLeft: '3px',
    "&[disabled]": {
      color: "grey",
      cursor: "default",
      textDecoration: "none"
    }
  },
  xsInputField: {
    paddingTop: '8px',
    paddingBottom: '8px',
  },
  greyShadowInputField: {
    outline: 'none',
    border: 'none',
    boxShadow: 'inset 0px 0px 50px -3px rgba(0,0,0,0.04)',
    borderRadius: '3px',
  },
  greyShadowInputFieldFocused: {
    boxShadow: 'inset 0px 0px 50px -3px rgba(0,0,0,0.02)',
  },
}));
